import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import LoginForm from './LoginForm';
import ForgotPasswordForm from './ForgotPasswordForm';
import { useAuth } from '../../components/providers/AuthProvider';
import { useNavigate } from 'react-router-dom';
import OtpPopup from '../../components/layouts/OtpPopup';
import { useApiBess } from '../../components/api/ApiBess';
import WelcomePanel from './WelcomePanel';
import background_login from '../../assets/images/login_wind_turbine.png';

const LoginPage = () => {

  const { user, login, verifyLogin, resetPassword, verifyResetPassword } = useAuth();

  const { getAvailableClusters } = useApiBess();

  // "login" or "forgot": which form the right-hand panel shows, and which flow the OTP code confirms
  const [mode, setMode] = useState("login");

  const [showOtpBox, setShowOtpBox] = useState(false);

  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);

  const [loading, setLoading] = useState(false);
  const [loginErrorMsg, setLoginErrorMsg] = useState("");

  const [verifying, setVerifying] = useState(false);
  const [verifyErrorMsg, setVerifyErrorMsg] = useState("");

  const navigate = useNavigate();

  const defaultRoute = "/index";

  const handleLogin = async ({email, password}) => {
    // console.log("Here", email, password);
    setEmail(email);
    setPassword(password);
    if (email && password && email !== "" && password !== "") {
      setLoginErrorMsg("");
      setLoading(true);
      const response = await login(email, password);
      console.log(response);
      if (response.code) {
        if (response.code === 101) {
          setShowOtpBox(true);
        }
        else {
          if (response.message) {
            setLoginErrorMsg(response.message)
          }
        }
      }
      setLoading(false);
    }
  };

  const handleResetPassword = async ({email, password}) => {
    setEmail(email);
    setPassword(password);
    setLoginErrorMsg("");
    setLoading(true);
    const response = await resetPassword(email, password);
    if (response.code) {
      if (response.code === 101) {
        setShowOtpBox(true);
      }
      else {
        if (response.message) {
          setLoginErrorMsg(response.message)
        }
      }
    }
    setLoading(false);
  };

  const switchMode = (newMode) => {
    setLoginErrorMsg("");
    setVerifyErrorMsg("");
    setMode(newMode);
  };

  const handleSubmitOtp = async (otp) => {
    setVerifyErrorMsg("");
    setVerifying(true);
    const response = mode === "forgot"
      ? await verifyResetPassword(email, otp)
      : await verifyLogin(email, otp);
    console.log(`Verify (${mode}) response:`, response);
    if (response.signedIn || (response.data && response.data.credentials)) {
      // Signed in; the user effect navigates away and closes the popup
    }
    else if (response.code) {
      if (response.code === 101) {
        setShowOtpBox(true);
      }
      else {
        setVerifyErrorMsg(response.message || `Verification failed (code ${response.code}).`)
      }
    }
    else {
      // Accepted the code but returned no token, so the user can't be signed in
      setVerifyErrorMsg("Code accepted, but no sign-in token was returned. Please sign in with your new password.");
    }
    setVerifying(false);
  }


  useEffect(() => {
    if (user) {
      console.log(user);
      setShowOtpBox(false);
      navigate(defaultRoute);
    }
  }, [user])

  return (
    <Box sx={{
      display: "flex",
      minHeight: "100vh",
      // The photo runs under both halves so the form panel blends with the welcome panel
      // Warm overlay: dark charcoal at the top fading into a sunset glow
      backgroundColor: "#171110",
      backgroundImage: `linear-gradient(160deg, rgba(23, 17, 16, 0.92) 0%, rgba(46, 31, 28, 0.74) 45%, rgba(234, 136, 64, 0.4) 100%), url(${background_login})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}>

      <OtpPopup
        visible={showOtpBox}
        setVisible={setShowOtpBox}
        submitOtp={handleSubmitOtp}
        loading={verifying}
        email={email}
        errorMessage={verifyErrorMsg}
      />

      <WelcomePanel />

      {/* Sign-in form */}
      <Box sx={{
        flex: "1 1 45%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 3,
        py: 6,
        // Frosted dark glass over the photo
        backgroundColor: "rgba(26, 19, 18, 0.72)",
        backdropFilter: "blur(18px)",
        borderLeft: { md: "1px solid rgba(255, 237, 213, 0.1)" },
      }}>
        {mode === "forgot"
          ? <ForgotPasswordForm
              loading={loading}
              errorMsg={loginErrorMsg}
              onSubmit={handleResetPassword}
              onBackToLogin={() => switchMode("login")}
            />
          : <LoginForm
              loading={loading}
              errorMsg={loginErrorMsg}
              onClick={handleLogin}
              onForgotPassword={() => switchMode("forgot")}
            />
        }
      </Box>
    </Box>
  )
}

export default LoginPage;
